import type { AppsflyerUidPayload } from '../types';
import { useUserJourneyStore } from '~/stores/apostatudo/user-journey';

export function handleAppsflyerUid(payload: AppsflyerUidPayload): void {
  if (!payload.uid) {
    return;
  }

  useUserJourneyStore().setAppsflyer({
    id: payload.uid,
    platform: payload.platform,
    advertising_id: payload.advertising_id,
    os_version: payload.os_version,
  });
}
